import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import loadingimage from '@images/lodingscreenBackImage.png';
import logo from '@images/sermyble_Logo.png';

const LoadingScreen: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Set timeout for 4 seconds and navigate to the login page
        const timer = setTimeout(() => {
            navigate('/login');
        }, 4000);

        // Cleanup the timer if the component unmounts before the timeout
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div
            style={{
                position: 'relative',
                height: '100vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
            }}
        >
            {/* Background image with blur */}
            <div
                style={{
                    backgroundImage: `url(${loadingimage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    filter: "blur(8px) brightness(0.7)",
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                }}
            />
            
            {/* Foreground content without blur */}
            <div
                style={{
                    zIndex: 1,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <div
                    style={{
                        backgroundColor: "#ffffffb0",
                        width: "400px",
                        height: "400px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                        animation: "fadeIn 2s ease-in-out",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            borderRadius: "50%",
                            width: 300,
                            height: 300,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            animation: "scaleIn 2s ease-in-out"
                        }}
                    >
                        <img src={logo} width={200} alt="Logo" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen;
